import api from '../../apiConfig/apiConfig'
import { Get, Post } from '../base/baseAjax'

let getMediafaxAccount = param => {
  return Get({
    url: api.dictApi.getCustomerAccount,
    UrlParam: param
  })
}
let getCustomerName = param => {
  return Get({
    url: api.dictApi.getCustomerName,
    UrlParam: param
  })
}

let getOperateAccount = param => {
  return Get({
    url: api.dictApi.getOperateAccount,
    UrlParam: param
  })
}

export function getDict(id) {
  return Get({
    url: api.dictApi.getDict + id
  })
}

// 获取工单创建中的关联订单号
let serviceCode = param => {
  return Post({
    url: api.workorder.saveworkorder,
    BodyParam: param
  })
}

export default {
  getMediafaxAccount,
  getCustomerName,
  getOperateAccount,
  getDict,
  serviceCode
}
